import { cn, Text } from "@aurem/ui";
import { useNavigation } from "hooks/navigate";
import { useLocation } from "react-router-dom";
import { SidebarItemData } from "./index";

type Props = {
  options: SidebarItemData[];
  closeDropdown: () => void;
  onClose?: () => void;
};

export const ShowMoreContent = ({ options, closeDropdown, onClose }: Props) => {
  const navigate = useNavigation();
  const { pathname } = useLocation();

  const handleClick = (to: string) => {
    navigate(to);
    closeDropdown();
    onClose?.();
  };

  const optionsJSX = options.map((option) => {
    const isActive = pathname.includes(option.to);

    return (
      <button
        key={option.id}
        role="menuitem"
        onClick={() => handleClick(option.to)}
        className={cn(
          "flex w-full items-center gap-3 px-3 rounded-lg focus:outline-none min-h-11",
          "focus-visible:outline focus-visible:outline-white focus-visible:outline-offset-[0]",
          "text-white",
          isActive ? "bg-white/20" : "hover:bg-white/10",
        )}
      >
        {option.icon && (
          <span className="flex h-4 w-4 items-center justify-center shrink-0">
            {option.icon}
          </span>
        )}
        <Text size="sm" className="flex-1 text-start">
          {option.label}
        </Text>
      </button>
    );
  });
  return (
    <div className="flex flex-col gap-[1px] p-1 bg-accent-500">
      {optionsJSX}
    </div>
  );
};
